import * as React from 'react';
import { IPromotion } from '../../../../types/builder/promotions';
import { ArticleParagraph1, Responsive } from '@cian/ui-kit';
import * as styles from './PromotionDetail.css';

interface IPromotionDetailProps extends IPromotion {
  phoneButton: React.ReactNode;
}

export const PromotionDetail: React.FC<IPromotionDetailProps> = ({ image, text, phoneButton }) => {
  return (
    <div className={styles['promotion-detail']}>
      <img src={image} width="100%" height="auto" />
      <ArticleParagraph1>{text}</ArticleParagraph1>
      <Responsive desktop tablet>
        {phoneButton}
      </Responsive>
    </div>
  );
};
